import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from 'react';
import RootLayout from "./components/RootLayout";
import LoadingSpinner from "./components/LoadingSpinner";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";

// Only Home is imported directly as it's the main page
import Home from "./pages/Home";

// Lazy load all other components
const Expertise = lazy(() => import("./pages/Expertise"));
const Contact = lazy(() => import("./pages/Contact"));
const Blog = lazy(() => import("./pages/Blog"));
const Litigation = lazy(() => import("./pages/practiceAreas/Litigation"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const RoleLogin = lazy(() => import("./pages/RoleLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const OperatorDashboard = lazy(() => import("./pages/OperatorDashboard"));
const ViewerDashboard = lazy(() => import("./pages/ViewerDashboard"));
const LoginForm = lazy(() => import("./components/auth/LoginForm"));
const RegisterForm = lazy(() => import("./components/auth/RegisterForm"));
const UserProfile = lazy(() => import("./components/user/UserProfile"));
const BusinessLaw = lazy(() => import("./pages/practiceAreas/BusinessLaw"));
const IntellectualProperty = lazy(() => import("./pages/practiceAreas/IntellectualProperty"));
const BankingLaw = lazy(() => import("./pages/practiceAreas/BankingLaw"));
const Patent = lazy(() => import("./pages/IP/patent"));
const Trademark = lazy(() => import("./pages/IP/trademark"));
const Copyright = lazy(() => import("./pages/IP/copyright"));
const IpSearchMonitoring = lazy(() => import("./pages/IP/ip-search-monitoring"));
const InternationalFiling = lazy(() => import("./pages/IP/international-filing"));
const Design = lazy(() => import("./pages/IP/design"));

export const router = createBrowserRouter(
  [
    {
      element: <RootLayout />,
      children: [{
    path: "/",
    element: <Home />,
},
{
    path: "/expertise",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <Expertise />
        </Suspense>
    ),
},
{
    path: "/contact",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <Contact />
        </Suspense>
    ),
},
{
    path: "/blog",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <Blog />
        </Suspense>
    ),
},
{
    path: "/practice-areas/litigation",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <Litigation />
        </Suspense>
    ),
},
{
    path: "/practice-areas/banking-law",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <BankingLaw />
        </Suspense>
    ),
},
{
    path: "/practice-areas/business-law",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <BusinessLaw />
        </Suspense>
    ),
},
{
    path: "/practice-areas/intellectual-property",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <IntellectualProperty />
        </Suspense>
    ),
},
{
    path: "/practice-areas/intellectual-property/patent",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <Patent />
        </Suspense>
    ),
},
{
    path: "/practice-areas/intellectual-property/trademark",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <Trademark />
        </Suspense>
    ),
},
{
    path: "/practice-areas/intellectual-property/copyright",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <Copyright />
        </Suspense>
    ),
},
{
    path: "/practice-areas/intellectual-property/ip-search-monitoring",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <IpSearchMonitoring />
        </Suspense>
    ),
},
{
    path: "/practice-areas/intellectual-property/international-filing",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <InternationalFiling />
        </Suspense>
    ),
},
{
    path: "/practice-areas/intellectual-property/design",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <Design />
        </Suspense>
    ),
},
{
    path: "/admin/login",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <AdminLogin />
        </Suspense>
    ),
},
{
    path: "/role-login",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <RoleLogin />
        </Suspense>
    ),
},
{
    path: "/admin/dashboard",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <AdminDashboard />
        </Suspense>
    ),
},
{
    path: "/operator/dashboard",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <OperatorDashboard />
        </Suspense>
    ),
},
{
    path: "/viewer/dashboard",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <ViewerDashboard />
        </Suspense>
    ),
},
{
    path: "/login",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <LoginForm />
        </Suspense>
    ),
},
{
    path: "/register",
    element: (
        <Suspense fallback={<LoadingSpinner />}>
            <RegisterForm />
        </Suspense>
    ),
},
{
    path: "/profile",
    element: (
        <ProtectedRoute>
            <Suspense fallback={<LoadingSpinner />}>
                <UserProfile />
            </Suspense>
        </ProtectedRoute>
    ),
},
{
    path: "/admin",
    element: (
        <ProtectedRoute requiredRole="admin">
            <Suspense fallback={<LoadingSpinner />}>
                <AdminDashboard />
            </Suspense>
        </ProtectedRoute>
    ),
}
      ]
    }  ]
);
